exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag.size-xs .tag-text[data-v-3596a4a8]{padding:0 4px;font-size:12px}", ""]);

// exports
